import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  configuration: {
    description: 'Subheader for the configuration section',
    defaultMessage: 'Configuration',
    id: 'nCdZyo',
  },
  noOnHandStockWarningOptionLabel: {
    description: 'Label for the no on hand stock warning option',
    defaultMessage: 'When shipping products that have <b>no on hand stock</b> remaining:',
    id: 'Ec7l4D',
  },
  unknownOnHandStockWarningOptionLabel: {
    description: 'Label for the unknown on hand stock warning option',
    defaultMessage: 'When shipping products that have an <b>unknown</b> on hand stock level:',
    id: 'myXYfF',
  },
  locationNotTrackingInvWarningOptionLabel: {
    description: 'Label for the location not tracking inventory warning option',
    defaultMessage: 'When shipping from a location <b>doesn’t track inventory:</b>',
    id: '/afkuf',
  },
  defaultThresholdWarningOptionLabel: {
    description: 'Label for the threshold warning option',
    defaultMessage: 'Create alerts for SKUs that fall below a set threshold',
    id: '/Qbfsu',
  },
  defaultThresholdInfo: {
    description: 'Information for the threshold warning option',
    defaultMessage: 'This is a default threshold that can be overwritten for each product in its details.',
    id: 'TTbZiR',
  },
  setThresholdWarningOption: {
    description: 'Description for the set threshold warning option',
    defaultMessage: 'Set Units',
    id: 'pa6pil',
  },
  units: {
    description: 'Information for the set threshold warning option',
    defaultMessage: '{units} Units',
    id: 'e9t2iR',
  },
  allowInventoryTracking: {
    description: 'Label for the enable inventory tracking option',
    defaultMessage: 'Allow Inventory tracking',
    id: 'KDVnbn',
  },
  recommended: {
    description: 'Inventory tracking recommended message as value',
    defaultMessage: 'Recommended',
    id: '3b+zB/',
  },
  enableInventoryTrackingDescription: {
    description: 'Description for the enable inventory tracking option',
    defaultMessage: 'Enable inventory tracking is required for inventory management, including Inventory Sync.',
    id: 'hw01pm',
  },
  disableInventoryTrackingTooltipHeader: {
    description: 'Header in confirmation modal when disabling inventory tracking',
    defaultMessage: 'Disable Inventory Confirmation',
    id: 'nNuxAl',
  },
  disableInventoryTrackingTooltipMessage: {
    description: 'Description in confirmation modal when disabling inventory tracking',
    defaultMessage:
      'Looks like you have used inventory recently. Disabling Inventory Management will <b>deallocate all existing orders and prevent further allocation until you enable it again.</b>',
    id: 'xMrA28',
  },
  warnOfInventoryAdjustmentOption: {
    description: 'One of the option for the inventory tracking option',
    defaultMessage: 'Warn of inventory adjustements',
    id: 'gVQjSS',
  },
  doNotWarnOfInventoryAdjustmentOption: {
    description: 'Label for the do not warn of inventory adjustment option',
    defaultMessage: 'Do not warn of inventory adjustments',
    id: 'ikilTj',
  },
  disableInventoryTrackingTooltipConfirmButton: {
    description: 'Confirm button in confirmation modal when disabling inventory tracking',
    defaultMessage: 'I Understand',
    id: 'JM7qvV',
  },
  editButton: {
    description: 'Button to start editing the configuration',
    defaultMessage: 'Edit',
    id: '4oOyRi',
  },
  saveButton: {
    description: 'Button to save the configuration',
    defaultMessage: 'Save',
    id: 'vzEROk',
  },
  cancelButton: {
    description: 'Button to cancel the configuration',
    defaultMessage: 'Cancel',
    id: 'mrP9/E',
  },
  enabled: {
    description: 'Inventory tracking enabled message as value',
    defaultMessage: 'Enabled',
    id: 'l063ou',
  },
  disabled: {
    description: 'Inventory tracking disabled message as value',
    defaultMessage: 'Disabled',
    id: 'TSztDL',
  },
});
